import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { BiX, BiTrash, BiMinus, BiPlus } from 'react-icons/bi';
import Button from '../common/Button';
import CartCal from './CartCal';
import { useSelector, useDispatch } from 'react-redux';
import { deleteCart, updateCartCount } from '../../store/actions';

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
  animation: modal-bg-show 0.5s;
  @keyframes modal-bg-show {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalBlock = styled.div`
  position: absolute;
  top: 60px;
  border-radius: 10px;
  padding: 40px;
  background-color: white;
  width: 80%;
  min-height: 600px;
  animation: modal-show 0.5s;
  @keyframes modal-show {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Close = styled.div`
  position: absolute;
  right: 40px;
  top: 40px;
  cursor: pointer;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const CartTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  td, th {
    text-align: center;
    padding: 12px 10px;
    border: none;
    font-size: 14px;
  }
  thead > tr {
    background-color: #eee;
    height: 50px;
  }
  tbody tr {
    height: 50px;
    border-bottom: 1px solid #f3f4f6;
  }
`;

const CountControl = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
`;

const CountBtn = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: #f9fafb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { background: #e5e7eb; }
  &:disabled { opacity: 0.3; cursor: not-allowed; }
`;

const CountInput = styled.input`
  width: 40px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const BottomSafe = styled.div`
  height: 150px;
`;

const ClearBtn = styled.button`
  padding: 10px 20px;
  border: 1.5px solid #ddd;
  border-radius: 10px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #dc2626;
  cursor: pointer;
  &:hover { background: #fef2f2; border-color: #fca5a5; }
`;

const CartModal = ({ _handleModal, children, ...rest }) => {
  const cart = useSelector((store) => store.cartReducer);
  const dispatch = useDispatch();

  const handleCountChange = (item, delta) => {
    const newCount = item.count + delta;
    if (newCount < 1) return;
    dispatch(updateCartCount(item.product_name, newCount));
  };

  return (
    <Container>
      <Background onClick={_handleModal} />
      <ModalBlock {...rest}>
        <Close onClick={_handleModal}>
          <BiX size="40" />
        </Close>
        <Contents>
          {cart.length === 0 ? (
            <div>
              <h3 style={{ marginTop: '250px' }}>장바구니가 비어 있습니다.</h3>
            </div>
          ) : (
            <>
              <h2>장바구니</h2>
              <CartTable>
                <thead>
                  <tr>
                    <th>제품</th>
                    <th>수량</th>
                    <th>가격</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((item, i) => (
                    <tr key={i}>
                      <td>{item.product_name}</td>
                      <td>
                        <CountControl>
                          <CountBtn
                            disabled={item.count <= 1}
                            onClick={() => handleCountChange(item, -1)}
                          >
                            <BiMinus size={16} />
                          </CountBtn>
                          <CountInput
                            type="number"
                            min="1"
                            value={item.count}
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              if (val > 0) dispatch(updateCartCount(item.product_name, val));
                            }}
                            onBlur={(e) => {
                              if (!e.target.value || parseInt(e.target.value, 10) < 1) {
                                dispatch(updateCartCount(item.product_name, 1));
                              }
                            }}
                          />
                          <CountBtn onClick={() => handleCountChange(item, 1)}>
                            <BiPlus size={16} />
                          </CountBtn>
                        </CountControl>
                      </td>
                      <td>{item.price.toLocaleString('ko-KR')}</td>
                      <td>
                        <BiTrash
                          size={20}
                          onClick={() => dispatch(deleteCart(item))}
                          style={{ cursor: 'pointer' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </CartTable>
              <BottomSafe />
              <CartCal />
              <div style={{ position: 'absolute', bottom: '40px', display: 'flex', gap: '12px', alignItems: 'center' }}>
                <ClearBtn onClick={() => dispatch({ type: 'CLEAR_CART' })}>전체 비우기</ClearBtn>
                <Link to="/order">
                  <Button onClick={_handleModal}>발주서 생성하기</Button>
                </Link>
              </div>
            </>
          )}
        </Contents>
      </ModalBlock>
    </Container>
  );
};

export default CartModal;
